// ── Hero slideshow ──
function initHeroSlideshow() {
  const slides = document.querySelectorAll('.hero-slide');
  const dots   = document.querySelectorAll('.slide-dot');
  if (!slides.length) return;
  let idx = 0, timer;

  function goTo(i) {
    slides[idx].classList.remove('active');
    dots[idx] && dots[idx].classList.remove('active');
    idx = i;
    slides[idx].classList.add('active');
    dots[idx] && dots[idx].classList.add('active');
  }
  function next() { goTo((idx + 1) % slides.length); }
  function start() { timer = setInterval(next, 3800); }
  function stop()  { clearInterval(timer); }

  dots.forEach((d, i) => d.addEventListener('click', () => { stop(); goTo(i); start(); }));
  window.heroGoTo = (i) => { stop(); goTo(i); start(); };
  start();
}

// ── Sticky nav ──
function initNav() {
  const nav = document.querySelector('.site-nav');
  if (!nav) return;
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 8);
  }, { passive: true });
}

// ── Scroll reveal ──
function initReveal() {
  const els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.12 });
  els.forEach(el => obs.observe(el));
}

// ── Newsletter ──
function initNewsletter() {
  const form = document.querySelector('.nl-form');
  if (!form) return;
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const btn  = form.querySelector('.nl-btn');
    const data = new FormData(form);
    btn.disabled = true;
    btn.textContent = 'Joining…';
    try {
      const res = await fetch(form.action, { method: 'POST', body: data, headers: { 'Accept': 'application/json' } });
      if (res.ok || res.redirected) {
        btn.textContent = "You're in ☺";
        btn.style.background = '#2C5A3E';
        form.querySelector('input[type="email"]').value = '';
      } else {
        btn.textContent = 'Try again';
        btn.disabled = false;
      }
    } catch {
      btn.textContent = 'Try again';
      btn.disabled = false;
    }
  });
}

// ── Product page ──
function initProductPage() {
  if (!document.querySelector('.product-page')) return;

  // Color → images map (populated by Liquid inline script on product.liquid)
  const colorImages = window.SmileColorImages || {};
  let currentColor = Object.keys(colorImages)[0] || '';
  let currentIdx = 0;

  function getImgs() { return colorImages[currentColor] || []; }

  function setThumb(idx) {
    currentIdx = idx;
    const imgs = getImgs();
    const mainImg = document.getElementById('main-img');
    if (!mainImg || !imgs[idx]) return;
    mainImg.classList.add('fade');
    setTimeout(() => { mainImg.src = imgs[idx]; mainImg.classList.remove('fade'); }, 220);
    const label = document.getElementById('view-label');
    if (label) label.textContent = idx === 0 ? 'Front' : 'Back';
    document.querySelectorAll('.thumb').forEach((t, i) => t.classList.toggle('active', i === idx));
  }

  window.thumbClick  = (idx) => setThumb(idx);
  window.prevImg     = () => setThumb(currentIdx === 0 ? 1 : 0);
  window.nextImg     = () => setThumb(currentIdx === 1 ? 0 : 1);

  window.selectColor = (el) => {
    const color = el.dataset.color;
    currentColor = color;
    currentIdx = 0;
    document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
    el.classList.add('active');
    const lbl = document.getElementById('color-label');
    if (lbl) lbl.textContent = color;
    const imgs = getImgs();
    const t0 = document.getElementById('thumb-0');
    const t1 = document.getElementById('thumb-1');
    if (t0) t0.src = imgs[0] || '';
    if (t1) t1.src = imgs[1] || '';
    const mainImg = document.getElementById('main-img');
    if (mainImg) {
      mainImg.classList.add('fade');
      setTimeout(() => { mainImg.src = imgs[0] || ''; mainImg.classList.remove('fade'); }, 220);
    }
    const label = document.getElementById('view-label');
    if (label) label.textContent = 'Front';
    document.querySelectorAll('.thumb').forEach((t, i) => t.classList.toggle('active', i === 0));

    // Sync Shopify variant selector
    syncVariant();
  };

  window.selectSize = (el) => {
    document.querySelectorAll('.size-btn:not(.soldout)').forEach(b => b.classList.remove('active'));
    el.classList.add('active');
    const lbl = document.getElementById('size-label');
    if (lbl) lbl.textContent = el.textContent;
    syncVariant();
  };

  function syncVariant() {
    const color = document.getElementById('color-label')?.textContent || '';
    const size  = document.getElementById('size-label')?.textContent || '';
    const variantSelect = document.getElementById('variant-id');
    if (!variantSelect) return;
    const opts = variantSelect.options;
    for (let o of opts) {
      if (o.dataset.color === color && o.dataset.size === size) {
        variantSelect.value = o.value;
        break;
      }
    }
  }

  window.changeQty = (delta) => {
    const input = document.getElementById('qty');
    if (!input) return;
    const val = parseInt(input.value) + delta;
    if (val >= 1 && val <= 10) input.value = val;
  };

  window.toggleWishlist = () => {
    const btn  = document.getElementById('wishlist-btn');
    const icon = document.getElementById('wish-icon');
    const text = document.getElementById('wish-text');
    if (!btn) return;
    const saved = btn.classList.toggle('saved');
    if (text) text.textContent = saved ? 'Saved to Wishlist' : 'Add to Wishlist';
    if (icon) icon.setAttribute('fill', saved ? 'currentColor' : 'none');
  };

  window.toggleAccordion = (trigger) => {
    const item   = trigger.closest('.accordion-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  };

  // Pre-select color from URL param — validate to safe characters only
  const params = new URLSearchParams(window.location.search);
  const c = params.get('color');
  if (c && /^[\w\s-]{1,64}$/.test(c)) {
    const swatch = document.querySelector(`.color-swatch[data-color="${CSS.escape(c)}"]`);
    if (swatch) window.selectColor(swatch);
  }
}

// ── Cart AJAX ──
function initCart() {
  const form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = document.getElementById('add-cart-btn');
    const variantId = parseInt(document.getElementById('variant-id')?.value, 10);
    const qty = parseInt(document.getElementById('qty')?.value || '1', 10);

    if (!variantId || isNaN(variantId)) { alert('Please select a size.'); return; }

    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });

      if (!res.ok) throw new Error();

      const cart = await fetch('/cart.js').then(r => r.json());
      const badge = document.querySelector('.cart-badge');
      if (badge) badge.textContent = cart.item_count;

      btn.textContent = 'Added! ✓';
      btn.style.background = '#2C5A3E';

      const toast = document.getElementById('toast');
      if (toast) { toast.classList.add('show'); setTimeout(() => toast.classList.remove('show'), 2800); }

      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.style.background = '';
        btn.disabled = false;
      }, 2500);

    } catch {
      btn.textContent = 'Add to Cart';
      btn.disabled = false;
      alert('Something went wrong. Please try again.');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initNav();
  initHeroSlideshow();
  initReveal();
  initNewsletter();
  initProductPage();
  initCart();
});
